import { render, staticRenderFns } from "./TaskIssueDianfuStepTwoKeyword.vue?vue&type=template&id=c7987554&"
import script from "./TaskIssueDianfuStepTwoKeyword.vue?vue&type=script&lang=js&"
export * from "./TaskIssueDianfuStepTwoKeyword.vue?vue&type=script&lang=js&"
import style0 from "./TaskIssueDianfuStepTwoKeyword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports